import React ,{ Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import notie from 'notie';
import '../../assets/css/notie.css';

const Perfil = props =>{
    const [pass,setPass] = useState({
        editar: true, 
        pass:'',
        new:'',
        confirm:''
    })
    
    const [error,setError] = useState(false)
    const [user,setUser] = useState({})
    const [src,setSrc] = useState({
        base:'/imagen_perfil',
        change:false,
        editar:false
    })
    
    const getData = async () =>{
        let response = await fetch('/info_user', {
            method: 'POST',
            body: JSON.stringify({}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            setUser(res.resultado);
        }
        catch{ }
    }
    useEffect(() => {
        getData();
    }, []);

    const subir = async () =>{ let response = await fetch('/profile_upload', {
            method: 'POST',
            body: JSON.stringify({base:src.base}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            if(res.estado){
                toast.success('Imagen subida')
                setTimeout(() => {
                    window.location.replace('/perfil')
                }, 1000);
            }
            else
                toast.warn('Error...')
        }
        catch{
            toast.warn('Error...')
        } }
    const eliminar = async () =>{ let response = await fetch('/profile_del', {
            method: 'POST',
            body: JSON.stringify({}),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            if(res.estado){
                toast.success('Imagen eliminada')
                setTimeout(() => {
                    window.location.replace('/perfil')
                }, 1000);
            }
            else
                toast.warn('Error...')
        }
        catch{
            toast.warn('Error...')
        } }
    
    const set= async()=>{
        if(pass.pass.length<=4 || pass.new.length<=4 || pass.confirm.length<=4){
            setError(true)
            notie.alert({ type: 'warning', text: 'Completa los datos', time: 2 })
            return
        }

        setError(false)

        if(pass.new !== pass.confirm){
            notie.alert({ type: 'warning', text: 'La nueva contraseña no coincide', time: 2 })
            return
        }

        let response = await fetch('/set_pass', {
            method: 'POST',
            body: JSON.stringify(pass),
            headers:{'Content-Type': 'application/json'}});
        try{
            let res = await response.json();
            if(res.resultado.error==1)
                notie.alert({ type: 'error', text: res.resultado.msg || 'No se pudo cambiar la contraseña', time: 2 })
            else{
                notie.alert({ type: 'success', text: 'Contraseña actualizada correctamente', time: 2 })
                setPass({
                    editar:true,
                    pass:'',
                    new:'',
                    confirm:''
                })
            }
        }
        catch{
            notie.alert({ type: 'error', text: 'Ocurrió un error al cambiar la contraseña', time: 2 })
        }
    }

    const handlePassChange = (name, value) => {
        setPass(prevPass => ({
            ...prevPass,
            [name]: value
        }));
    };

    return(
        <Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12 mt-3">
                        <div className="row">
                            <div className="col-sm-8"><h4>Perfil</h4></div>
                        </div>
                    </div>
                <div className="col-sm-12 col-xl-12 xl-100">
                        <div className="card height-equal mt-2">
                            <div className="card-body">
                                <div className="row mb-5">
                                    <div className="col-auto"><img className="img-70 rounded-circle" alt="" src={src.base} /></div>
                                    <div className="col">
                                        <h3 className="mb-1">{user.nombre} {user.apellidos}</h3>
                                        {src.editar?
                                            <Fragment>
                                                {src.change?
                                                    <Fragment>
                                                        <a className="text-primary">{src.option} imagen</a>
                                                        <br></br>
                                                        <a className="text-success mr-2"
                                                            style={{cursor:'pointer'}}
                                                            onClick={()=>{
                                                                if(src.option=='Subir')
                                                                    subir()
                                                                if(src.option=='Eliminar')
                                                                    eliminar()
                                                            }}
                                                        >Aceptar</a>
                                                        <a className="text-danger"
                                                            style={{cursor:'pointer'}}
                                                            onClick={()=>{
                                                                setSrc({
                                                                    base:'/imagen_perfil',
                                                                    change:false,
                                                                    editar:false
                                                                })
                                                            }}
                                                        >Cancelar</a>
                                                    </Fragment>
                                                :
                                                    <Fragment>
                                                        <a className="text-primary" 
                                                            style={{cursor:'pointer'}}
                                                            onClick={()=>{
                                                                var input = document.createElement('input');
                                                                input.type = 'file';
                                                                input.accept='image/*';
                                                                input.onchange = e =>{
                                                                    var reader = new FileReader();
                                                                    reader.onloadend = function () {
                                                                        var b64 = reader.result;
                                                                        setSrc({
                                                                            base:b64,
                                                                            change:true,
                                                                            option:'Subir',
                                                                            editar:true
                                                                        })
                                                                    };
                                                                    reader.readAsDataURL(e.target.files[0]);
                                                                }
                                                                input.click();
                                                            }}
                                                        >Subir imagen</a>
                                                        <br></br>
                                                        <a className="text-danger"
                                                            style={{cursor:'pointer'}}
                                                            onClick={()=>{
                                                                setSrc({
                                                                    base:'/imagen_perfil',
                                                                    change:true,
                                                                    option:'Eliminar',
                                                                    editar:true
                                                                })
                                                            }}
                                                        >Eliminar imagen</a>
                                                    </Fragment>
                                                }
                                            </Fragment>
                                        :
                                            <Fragment>
                                                <a className="text-primary"
                                                    style={{cursor:'pointer'}}
                                                    onClick={()=>{
                                                        setSrc({
                                                            base:'/imagen_perfil',
                                                            change:false,
                                                            editar:true
                                                        })
                                                    }}
                                                >Cambiar imagen</a>
                                            </Fragment>
                                        }
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Correo</label>
                                    <input className="form-control" value={user.correo} disabled/>
                                </div>
                                
                                <div className="row">
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Contraseña Actual</label>
                                        <input 
                                            id="set-pass-pass" 
                                            className="form-control" 
                                            type="password" 
                                            value={pass.pass} 
                                            onChange={e => handlePassChange('pass', e.target.value)}
                                        />
                                    </div>
                                    
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Nueva Contraseña</label>
                                        <input 
                                            id="set-pass-new" 
                                            className="form-control" 
                                            type="password" 
                                            value={pass.new}
                                            onChange={e => handlePassChange('new', e.target.value)}
                                        />
                                    </div>
                                    
                                    <div className="form-group col-sm-4">
                                        <label className="form-label">Confirmar</label>
                                        <input 
                                            id="set-pass-confirm" 
                                            className="form-control" 
                                            type="password" 
                                            value={pass.confirm}
                                            onChange={e => handlePassChange('confirm', e.target.value)}
                                        />
                                    </div>
                                    
                                    <div className="form-footer col-sm-12 text-center mt-3"> 
                                        {error? <a className="text-danger mb-2">Completa los datos</a>:''}
                                        <a className="btn-primary text-center text-white mb-2 mr-2" style={{cursor:'pointer', padding: '10px 28px', borderRadius: '4px'}} onClick={set}>Guardar</a>
                                        
                                        <a className="btn-danger text-white text-center"
                                            style={{cursor:'pointer', padding: '10px 28px', borderRadius: '4px'}}
                                            onClick={()=>setPass({
                                                editar:true,
                                                pass:'',
                                                new:'',
                                                confirm:''
                                            })}
                                        >Cancelar</a>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </Fragment>
    )
}

export default Perfil;
